let state = {
  
    statusLogin: false,


}

export default state